import * as React from 'react';

import { DealCardBadge } from './DealCardBadge';
import { DealCardDate } from './DealCardDate';
import { DealCardDescription } from './DealCardDescription';
import { DealCardPhone } from './DealCardPhone';
import { DealCardSubtitle } from './DealCardSubtitle';
import { DealCardTitle } from './DealCardTitle';

import type { IDealCardData } from '../../model/deal';

export const DealCard = ({
    dealCardData,
    deleteBtnSlot,
}: {
    dealCardData: IDealCardData;
    deleteBtnSlot?: React.ReactNode;
}) => (
    <div className="group relative flex cursor-pointer flex-col gap-4.5 overflow-hidden rounded-lg bg-white p-3 transition-shadow hover:shadow-sm">
        <header className="flex w-full items-baseline justify-between gap-2.5 text-xs">
            <div className="flex flex-col items-baseline justify-between gap-1">
                <DealCardTitle
                    area={dealCardData.area}
                    name={dealCardData.name}
                    objectType={dealCardData.objectType}
                    unit={dealCardData.unit}
                />

                <DealCardSubtitle
                    customerName={dealCardData.customerName}
                    budget={dealCardData.approximateBudget}
                />
            </div>

            <div className="flex flex-col items-end gap-1 text-smtr-main-tertiary-100">
                {dealCardData?.receivedAt && <DealCardDate date={dealCardData?.receivedAt} />}
                {dealCardData?.source && <DealCardBadge textContent={dealCardData.source} />}
            </div>
        </header>
        <main className="flex flex-col gap-3">
            <DealCardPhone objectPhone={dealCardData.phone} />
            {dealCardData.requestEssence && (
                <DealCardDescription description={dealCardData.requestEssence} />
            )}
        </main>
        {deleteBtnSlot}
    </div>
);
